module.exports = __webpack_public_path__ + "static/media/licence2.868acba7.png";